<div class="insurer-card" [ngClass]="first ? 'highlight' : ''" data-progress-card>
  <ng-container [ngSwitch]="partnerCode">
    <ng-container *ngSwitchDefault>
      <img
        *ngIf="first"
        class="cheapest-tag"
        [src]="
          'https://storage.googleapis.com/dev-ps-asset/affiliate/logo/Tag-' +
          translate.currentLang +
          '.png'
        "
      />

      <img
        *ngIf="
          !first &&
          showTag &&
          !['ktmb', 'prolindung', 'lalamove'].includes(partnerCode)
        "
        [src]="getRibbonType(item?.code)"
        alt="eHailing Ribbon"
        class="affiliate-ribbon"
      />
    </ng-container>

    <ng-container *ngSwitchCase="'ps'">
      <img
        *ngIf="first && translate.currentLang === 'en'"
        class="cheapest-tag"
        src="assets/image/insurer-card-cheapest-tag.png"
      />
      <img
        *ngIf="first && translate.currentLang !== 'en'"
        class="cheapest-tag"
        src="https://storage.googleapis.com/dev-ps-asset/affiliate/logo/Tag-bm.png"
      />
    </ng-container>

    <ng-container *ngSwitchCase="'grab'">
      <img
        [src]="getRibbonType(item?.code)"
        alt="eHailing Ribbon"
        class="affiliate-ribbon"
        *ngIf="ehailingUsed"
      />
      <img
        *ngIf="item?.code === 'RHB' && vehicleType == 'Motorcycle'"
        class="insurance-type-tag"
        [src]="
          'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/TP-tag-' +
          translate.currentLang +
          '.png'
        "
      />
      <img
        *ngIf="item?.code !== 'RHB' && vehicleType == 'Motorcycle'"
        class="insurance-type-tag"
        [src]="
          'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/COM-tag-' +
          translate.currentLang +
          '.png'
        "
      />
    </ng-container>

    <ng-container *ngSwitchCase="'foodpanda'">
      <img
        *ngIf="item?.code === 'RHB'"
        class="insurance-type-tag"
        [src]="
          'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/TP-tag-' +
          translate.currentLang +
          '.png'
        "
      />
      <img
        *ngIf="item?.code !== 'RHB'"
        class="insurance-type-tag"
        [src]="
          'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/COM-tag-' +
          translate.currentLang +
          '.png'
        "
      />
    </ng-container>
    <ng-container *ngSwitchCase="'lalamove'">
      <img
        *ngIf="item?.code === 'RHB' && showTag && vehicleType == 'Motorcycle'"
        class="insurance-type-tag"
        [src]="
          'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/TP-tag-' +
          translate.currentLang +
          '.png'
        "
      />
      <img
        *ngIf="item?.code !== 'RHB' && showTag && vehicleType == 'Motorcycle'"
        class="insurance-type-tag"
        [src]="
          'https://storage.googleapis.com/dev-ps-asset/motorcycle/shared/COM-tag-' +
          translate.currentLang +
          '.png'
        "
      />
    </ng-container>
  </ng-container>

  <div class="insurer-card__header" [ngClass]="first ? 'highlight' : ''">
    <div class="insurer-card__header-logo">
      <img [src]="item?.image" />
    </div>
    <div class="insurer-card__pricing">
      <div>
        <span>RM</span>
        <ng-container>
          <ng-container>
            <span class="price-value">{{
              totalPrice | number : "1.2-2"
            }}</span>
          </ng-container>
        </ng-container>
      </div>
      <div
        class="rebate"
        [ngClass]="first ? 'highlight' : ''"
        *ngIf="item?.rebate"
      >
        <span>
          {{ "common.priceBeforeRebate" | translate }} :
          <span class="strikethrough"
            >RM{{ totalBasePremium | number : "1.2-2" }}</span
          >
        </span>
        <span class="rebate-note">
          {{ "common.epp" | translate }}
        </span>
      </div>

      <div *ngIf="item?.ncd > 0" class="price-value-ncd">
        <span>RM</span>
        <span>{{ totalPriceWithoutNcd | number : "1.2-2" }}</span>
     </div>

      <!-- Sum Insured Section -->
      <div class="sum-insured-with-badge">
        <!-- Badge if present -->
        <span
          *ngIf="item?.sumInsuredRange === 'Highest'"
          class="sum-insured__badge_Highest"
        >
          {{ "common.Highest" | translate }}
        </span>
        <span
          *ngIf="item?.sumInsuredRange === 'Lowest'"
          class="sum-insured__badge_Lowest"
        >
          {{ "common.Lowest" | translate }}
        </span>

        <!-- Sum Insured Text -->

        <div class="sum-insured">
          <span
            >{{
              (item.isTakaful ? "common.sumCovered" : "common.sumInsured")
                | translate
            }}
            ({{ "common." + item.typeOfSum | translate }}):
          </span>
          <span> RM {{ item.sumInsured | number : "1.2-2" }}</span>
        </div>
      </div>

      <!-- [PSSR-2072] Sum Insured Range Indicator - Show Range if TypeOfSum = AV and MinAVSI has value -->
      <div
        class="sum-insured-range"
        *ngIf="item.typeOfSum === 'AV' && item.minAVSI > 0"
      >
        <div>Min AV - Max AV</div>
        <div>
          RM {{ item.minAVSI | number : "1.2-2" }} - RM
          {{ item.maxAVSI | number : "1.2-2" }}
        </div>
      </div>
    </div>
  </div>

  <div class="insurer-card__content">
    <div class="insurer-card__benefit">
      <ng-container *ngIf="ehailingUsed">
        <img
          *ngIf="dailyEhailingInsurer.includes(item?.code) && translate.currentLang === 'en'"
          class="ehailing-banner"
          src="https://storage.googleapis.com/ps-asset/motor/d2c/daily-ehailing-banner.png"
        />
        <img
          *ngIf="dailyEhailingInsurer.includes(item?.code) && translate.currentLang !== 'en'"
          class="ehailing-banner"
          src="https://storage.googleapis.com/ps-asset/motor/d2c/daily-ehailing-banner-bm.png"
        />
        <img
          *ngIf="annualEhailingInsurer.includes(item?.code) && translate.currentLang === 'en'"
          class="ehailing-banner"
          src="https://storage.googleapis.com/ps-asset/motor/d2c/annual-ehailing-tag.png"
        />
        <img
          *ngIf="annualEhailingInsurer.includes(item?.code) && translate.currentLang !== 'en'"
          class="ehailing-banner"
          src="https://storage.googleapis.com/ps-asset/motor/d2c/annual-ehailing-tag-bm.png"
        />
        <img
          *ngIf="annualEhailingOnlyInsurer.includes(item?.code) && translate.currentLang === 'en'"
          class="ehailing-banner"
          src="https://storage.googleapis.com/ps-asset/motor/d2c/annual_ehailing_only-tag-en.png"
        />
        <img
          *ngIf="annualEhailingOnlyInsurer.includes(item?.code) && translate.currentLang !== 'en'"
          class="ehailing-banner"
          src="https://storage.googleapis.com/ps-asset/motor/d2c/annual-ehailing-only-tag-bm.png"
        />
      </ng-container>
      <div class="banefits-title">
        <h3>{{ "benefits.benefits" | translate | titlecase }}</h3>
        <span class="tnc-note">
          {{
            (item.isTakaful
              ? "benefits.benefits_tnc_takaful"
              : "benefits.benefits_tnc"
            ) | translate
          }}
        </span>
      </div>
      <ul>
        <ng-container *ngFor="let benefit of benefits">
          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'driver'
            "
          >
            <img src="assets/image/protection-drivers.svg" />
            <span
              >{{ "benefits.protectedDriver" | translate }}:
              <b class="color-dark-green">{{
                benefit.description | translate
              }}</b>
            </span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type === 'allRider'
            "
          >
            <img
              style="min-width: 24px !important"
              src="assets/image/admin_panel_settings.svg"
            />
            <span>
              <span [innerHTML]="benefit.description | translate"></span>
            </span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'towing'
            "
          >
            <img src="assets/image/towing-service.svg" />

            <span
              >{{ "benefits.towingService" | translate }}
              <b class="color-dark-green">{{
                benefit.description | translate
              }}</b></span
            >
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) &&
              benefit.type === '24hrTowingMotorcycle'
            "
          >
            <img src="assets/image/towing-service.svg" />

            <span
              >{{ "insurerDetails.24hrTowingService" | translate }}
              <b class="color-dark-green">{{
                benefit.description | translate
              }}</b></span
            >
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) &&
              benefit.type == '24hrTowing'
            "
          >
            <img src="assets/image/towing-service.svg" />

            <span
              >{{ "insurerDetails.24hrTowingService" | translate }}
              <b class="color-dark-green">{{
                benefit.description | translate
              }}</b></span
            >
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'free'
            "
          >
            <mat-icon class="color-dark-green">check_circle</mat-icon>
            <span
              ><b class="color-dark-green">{{ "benefits.free" | translate }}</b>
              {{ benefit.description | translate }}</span
            >
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'included'
            "
          >
            <mat-icon class="color-dark-green">check_circle</mat-icon>
            <span
              ><b class="color-dark-green">{{ "benefits.included" | translate }}</b>
              {{ benefit.description | translate }}</span
            >
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'thumbUp'
            "
          >
            <img src="assets/image/thumb_up.svg" />
            <span>
              {{ benefit.description | translate }}
            </span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'check'
            "
          >
            <mat-icon class="color-dark-green">check_circle</mat-icon>
            <span>{{ benefit.description | translate }}</span>
          </li>

          <li *ngIf="hasTranslation(benefit.description) && benefit.type == ''">
            <mat-icon class="color-yellow">star</mat-icon>
            <span>{{ benefit.description | translate }}</span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) &&
              benefit.type == 'sectionTitle'
            "
          >
            <span>{{ benefit.description | translate }}</span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'towingEV'
            "
          >
            <img src="https://storage.googleapis.com/ps-asset/ps_icons/towing-icon.png" />
            <span>
              <b class="color-dark-green">{{ "benefits.free" | translate }}</b>
              {{ benefit.description | translate }}
            </span>
          </li>

          <li
            *ngIf="
              hasTranslation(benefit.description) && benefit.type == 'ev'
            "
          >
            <img src="https://storage.googleapis.com/ps-asset/ps_icons/ev-icon.png" />
            <span>
              <b class="color-dark-green">{{ "benefits.included" | translate }}</b>
              {{ benefit.description | translate }}
            </span>
          </li>
        </ng-container>
      </ul>

      <button
        class="btn-text btn-text--blue mb-sm"
        (click)="toggleMoreBenefits()"
        *ngIf="totalBenefits > 4"
      >
        {{
          showMoreBenefits
            ? ("benefits.lessBenefits" | translate)
            : ("benefits.seeAll" | translate) +
              totalBenefits +
              " " +
              ("benefits.benefits" | translate)
        }}
        ...
      </button>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div class="insurer-card__footer">
    <button mat-flat-button class="full-btn" (click)="handleBuyNow()">
      {{ "comparison.selectPlan" | translate }}
    </button>
    <div class="mb-md">
      <div
        class="instalment-note"
        *ngIf="eppEligibility && eppEligibility.isEligible"
      >
        {{ "common.pay" | translate }}
        <b
          >RM{{
            totalBasePremiumAfterRebate / eppEligibility.months
              | number : "1.2-2"
          }}</b
        >
        <span> {{ "common.everyMonth" | translate }}</span>
        <span>
          {{
            eppEligibility.months == 6
              ? ("common.duration6" | translate)
              : ("common.duration12" | translate)
          }}
          <br
        /></span>
        <span>
          {{ "common.epp" | translate }}
        </span>
      </div>
      <div class="rebate-note" *ngIf="item?.rebate">
        <img src="assets/image/rebate-crown-icon.png" />
        {{ "common.includedRebate" | translate }}
        <b>RM{{ item?.rebate | number : "1.2-2" }}</b>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="insurer-card__documents">
      <ng-container
        *ngFor="let doc of documents; let i = index; let last = last"
      >
        <a class="btn-text" (click)="openDocLink(doc.url)">
          <mat-icon>open_in_new</mat-icon>
          <span>{{ doc.name }}</span>
        </a>
        <span *ngIf="!last" class="document-divider">|</span></ng-container
      >
    </div>
  </div>
</div>
